import {AfterViewInit, Component,  ElementRef, OnDestroy, Input, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription} from "rxjs";
import {ActivatedRoute, Params} from '@angular/router';
import {MaterialInstance, MaterialService} from "../../shared/classes/material.service";
import {PanelVisibilityService} from '../../shared/services/panel-visibility.service'
import {AuthService} from "../../shared/services/auth.service";
import {StreamsService}  from "../../shared/services/streams.service";
import {StreamProject} from "../../shared/interfaces";
import {switchMap, map, delay} from 'rxjs/operators';
import { Socket } from 'ngx-socket-io';
import { SocketVideosControl } from '../../shared/services/sockets'
import {VideoPlayerComponent} from '../../shared/components/video-player/video-player.component'
import {domain, protocol} from '../../shared/config';
import {  NbToastrService, NbGlobalPosition, NbDialogService } from '@nebular/theme';
 import {StreamSettingsComponent} from '../../shared/components/stream-settings/stream-settings.component';
 import {ModalUploadVideoComponent} from '../modals/modal-upload-video/modal-upload-video.component';
  import {StreamInfoComponent} from '../../shared/components/stream-settings/stream-info/stream-info.component';
import {visibilityPanelAnimation} from "../../shared/classes/visibility-panel.animation";

@Component({
  selector: 'app-video-overview',
  templateUrl: './video-overview.component.html',
  styleUrls: ['./video-overview.component.scss'],
  animations: [visibilityPanelAnimation]
}) 
export class VideoOverviewComponent implements OnInit, OnDestroy{

 
  @Input() video: StreamProject;

   @ViewChild('infoComponent') infoComponent:StreamInfoComponent;
 
 
  /*stream$:Observable<StreamProject> */
  domain: any = {
    name: domain, protocol
  }
  togglePublish$:any
  projectId: string
  videoSrc: string
  openSettingsCb:any
   frameCode: string
  frameCodeLink: string
  frameChatCode: string
  frameChatCodeLink: string
   publish: boolean
 proccessingProgress: number = 0
  viewersQuantity: any = 0
  initialLoading: boolean = true
  disconnectTimer = null
  settingsModalInstance: any = null
 

   constructor(
    public streamsService: StreamsService,
    public route:  ActivatedRoute,
    private socket: SocketVideosControl,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private authService: AuthService,
    public panelVisibility: PanelVisibilityService
    ){
	//  this.socket.disconnect()
    //  this.socket.removeAllListeners()
    
	this.openSettingsCb = this.openSettings.bind(this)
      if(this.togglePublish$){

	 this.togglePublish$.unsubscribe()
	}
  }

 

  ngOnInit() { 
 
 
    this.publish = this.video.publish

     
 
		this.frameCodeLink = `${this.domain.protocol}${this.domain.name}/watch-embed?v=${this.video.publicIdentity}`
     this.frameCode = `<iframe livestreamEmbed src="${this.frameCodeLink}" width="560" height="315" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> `

	this.frameChatCodeLink = `${this.domain.protocol}${this.domain.name}/chat-embed?v=${this.video.publicIdentity}`
 
	this.frameChatCode = `<iframe livestreamEmbedChat src="${this.frameChatCodeLink}" width="350" height="550" frameborder="0" allowfullscreen></iframe> `

    this.videoSrc =   `/video/`+ this.video.streamKey+'/index.m3u8'

    this.projectId = this.video._id

    //this.socket.on('uploadStatusChanged', this.uploadStatusChanged.bind(this))
    if(!this.video.staticVideoInfo.complete){
    
	this.socket.on('thumbLoaded', (data )=>{

		this.video.coverImage =  data.coverImage
		this.video.thumbImage =  data.thumbImage

	})

	this.socket.on('onProccessingProgress', (percents )=>{
		
		this.proccessingProgress =  percents

	})
   	 this.socket.on('uploadStatusChanged', (data)=>{
 
	 this.video.staticVideoInfo = {...this.video.staticVideoInfo, ...data}
	


	})
   }



    this.socket.on('connect', ()=>{
 
	
      this.socket.emit('onJoin', 
      {
        identity :  this.projectId,
	user: this.video.user,
        streamKey: this.video.streamKey
      })  
 
	// setTimeout(()=>{}, 3000)
      this.initialLoading = false 
 
    })

  
 
    //this.socket.on(socketEvents.viewersChanged, this.viewersChanged.bind(this))
 

    this.socket.connect()
 
  }
  
 
  viewersChanged(data){

      this.viewersQuantity = data

  }
  openEditInfo(){

	this.infoComponent.openEdit()
}


  videoStatusChanged(data){
  
  }


 
  
 
   ngOnDestroy() { 

  	this.socket.disconnect()
	/*  */
	this.socket.removeAllListeners('connect') 
	this.socket.removeAllListeners('onProccessingProgress')
	this.socket.removeAllListeners('uploadStatusChanged') 
   	this.socket.removeAllListeners('thumbLoaded') 

      //this.socket.removeAllListeners()
   }
 


   showToastCopyClipboard(text){

    this.toastrService.show('',text,{
      status: 'primary',
      icon: '',
      position: <NbGlobalPosition>'bottom-end'
        })
   }



  
   openUploadModal(){
   
    this.dialogService.open(ModalUploadVideoComponent, {
     // dialogClass: 'scrollable-container',
	/**/ closeOnBackdropClick:false,
 	closeOnEsc:false, 
	hasScroll: true, 
      context: {
        video: this.video,
	socket: this.socket 
    
      },
    });

	 
   }

 openSettings(chatMode = false){
  if(!this.video.staticVideoInfo.complete){
			
	    this.toastrService.show('','Необхідно завантажити відео',{
	      status: 'warning',
	      icon: '',
	      position: <NbGlobalPosition>'bottom-end'
		})
		
		 return
	} 
     this.dialogService.open(StreamSettingsComponent, {
      dialogClass: 'settings-modalsscrollable-container',
      context: {
        stream: this.video, 
        hasSignal: false,
 chatMode
      },
    });

	
 

   }
/*

   openSettings(){
 

	 if(!this.video.staticVideoInfo.complete){
			
	    this.toastrService.show('','Необходимо загрузить видео',{
	      status: 'warning',
	      icon: '',
	      position: <NbGlobalPosition>'bottom-end'
		})
		
		 return
	} 
 
    this.settingsModalInstance =  this.dialogService.open(StreamSettingsComponent, {
      dialogClass: 'scrollable-container',
	 hasScroll: true,    
      context: {
        stream: this.video, 
        hasSignal: false,
       // onRestreamSaved: this.restreamsSavedCb.bind(this)
      },
    });

	

      
    this.settingsModalInstance.onClose.subscribe(()=>{
       this.settingsModalInstance = null
    })


   } */
   



	
  togglePublish(){

 
    this.togglePublish$ = this.streamsService
    .updatePublish(this.video._id,this.publish)
	     .subscribe((video : StreamProject)=>{
 
	      this.publish = video.publish
	     this.video.publish = video.publish

	    }, ()=>{
	      this.publish = this.video.publish
	    })
	 
  }




  
}
